import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHero from '../components/PageHero';
import HowItWorksSection from '../components/HowItWorks';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';
import { useReferralCta } from '../hooks/useReferralCta';
import { trackCtaClick } from '../utils/analytics';

export default function HowItWorks() {
  const { ctaUrl } = useReferralCta();
  return (
    <>
      <PageHero
        eyebrow="How it works"
        title="From assessment to follow-up — one calm path."
        subtitle="AI-assisted intake, licensed doctor review, personalised plan, licensed pharmacy fulfilment where appropriate, and ongoing support — without paperwork or guesswork."
      />

      <Reveal><HowItWorksSection /></Reveal>

      <section className="bg-white">
        <div className="container-x py-12 sm:py-16">
          <Reveal>
            <div className="card-soft p-7 sm:p-10 grid sm:grid-cols-2 gap-6 items-center">
              <div>
                <h3 className="text-2xl font-bold tracking-tight">Ready to take the first step?</h3>
                <p className="mt-2 text-ink-600">
                  Set up your profile in under a minute. We'll guide you to the
                  right pathway — assessment, doctor review and follow-up.
                </p>
              </div>
              <div className="flex flex-wrap gap-3 sm:justify-end">
                <Link
                  to="/weight-management"
                  onClick={() => trackCtaClick({ page: 'how_it_works', button_label: 'Explore programme', destination: '/weight-management' })}
                  className="btn-outline"
                >
                  Explore programme
                </Link>
                <a
                  href={ctaUrl}
                  onClick={() => trackCtaClick({ page: 'how_it_works', button_label: 'Get started', destination: 'portal_register' })}
                  className="btn-brand"
                >
                  Get started <ArrowRight size={16} />
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
